import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UserDetailModel} from '../dto/user-detail.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /** check user **/
  login({username, password}): Observable<Object> {
    return this.httpClient.post(`${this.BASE_URL}systemUsers/signin`, {username, password}, {
      headers: this.headers
    });
  }

  /** Save System User Details **/
  saveSystemUser(userDetailModel: UserDetailModel){
    return this.httpClient.post(this.BASE_URL + 'systemUsers/signup' , userDetailModel,{responseType: 'text'});
  }

  /** Reset Password **/
  resetPassword(userDetailMode: UserDetailModel) {
    return this.httpClient.post(this.BASE_URL + 'systemUsers/reset' , userDetailMode,{responseType: 'text'});
  }

  /** Get All System Users **/
  getAllSystemUsers() {
    return this.httpClient.get(this.BASE_URL + 'systemUsers/all');
  }

  /** Search System User **/
  getSystemUserByName(name: string){
    return this.httpClient.post(this.BASE_URL + 'systemUsers/'+name, { headers: this.headers });
  }
}
